import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _lowerCase from 'lodash/lowerCase';
/**
 * make rule product factory
 * @param {Function} convertAndFormat convert and format price util
 * @returns {Function} ruleProductFactory
 */
export function makeRuleProductFactory(convertAndFormat) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return x;
    };
  }
  /**
   * rule product factory
   * @param {Object} rule plain unformatted rule product from cart's products
   * @returns {Object} formatted rule product
   */
  return function ruleProductFactory(rule) {
    var totalPrice = _get(rule, 'price.total');
    var totalWithVat = _get(rule, 'price.totalWithVat');
    var description = _get(rule, 'description');
    return {
      description: description,
      totalPrice: totalPrice,
      totalWithVat: totalWithVat,
      displayedTotalPrice: convertAndFormat(totalPrice),
      displayedCurrency: _get(rule, 'displayPrice.currency'),
      isServiceFee: _includes(_lowerCase(description), 'service fee'),
      isDiscount: Math.sign(totalPrice) === -1
    };
  };
}